import { NgModule } from '@angular/core';
import { DeviceSystemActivityLogPageRoutingModule } from './device-system-activity-log-routing';

@NgModule({
  imports: [DeviceSystemActivityLogPageRoutingModule],
})
export class DeviceSystemActivityLogPageModule {}
